import axios from 'axios';

const getAllProductsApi = async (paramsFilter, token, langIsoCode) => {
  try {
    const url = `/Product/all?status=${paramsFilter?.status || ''}&store_id=${
      paramsFilter?.store_id || ''
    }&page=${paramsFilter?.page || 1}`;
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default getAllProductsApi;
